import gql from "graphql-tag";

const queryAllCountries = gql`
  query countries($search: String) {
    countries(fullnameIcontains: $search, first: 10) {
      edges {
        node {
          id
          name
          alternateNames
        }
      }
    }
  }
`;

export default queryAllCountries;